import { useEffect, useRef, useState } from 'react'
import { useVehiclesService } from './useVehiclesService'

// Igual que la app: el plan de datos solo existe para motos con dispositivo.
// `hasDevice` viene de afuera porque /v1/vehiculos no siempre trae el imei a la web;
// una moto que envía posiciones por GPS también tiene dispositivo.
const usePlanStatus = (vehicle, hasDevice) => {
  const [plan, setPlan] = useState(null)
  const { getPlanStatus } = useVehiclesService()
  const getPlanStatusRef = useRef(getPlanStatus)
  getPlanStatusRef.current = getPlanStatus
  const chasis = vehicle?.value

  useEffect(() => {
    setPlan(null)
    if (!chasis || !hasDevice) return undefined
    let active = true
    getPlanStatusRef.current(chasis).then((data) => {
      if (!active || !data?.message_code) return
      setPlan({
        chasis,
        code: data.message_code,
        message: data.message || null,
        description: data.message_description || null,
        activationDate: data.trakku_activation || null,
        dueDate: data.trakku_due_date || null,
      })
    })
    return () => {
      active = false
    }
  }, [chasis, hasDevice])

  return plan
}

export { usePlanStatus }
